import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {classToClass, plainToClass} from 'class-transformer';
import {ConfirmationService, SelectItem} from 'primeng/api';

import {UserService} from '@app/core';
import {CommonTransformationService, DialogStyle40, Format, HrService, PrimeNgConfig, PrimeNgSupportService, SalaryHistory, TableColumn, TableFormat, Validation} from '@app/shared';

import {SalaryHistoryDataService} from './salary-history-data.service';

@Component({
  selector: 'app-salary-history',
  templateUrl: './salary-history.component.html',
  styleUrls: ['./salary-history.component.css'],
  providers: [SalaryHistoryDataService]
})
export class SalaryHistoryComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() userId: number;
  @Input() salaryHistories: SalaryHistory[];

  // standard format and validation
  Format: typeof Format = Format;
  Validation: typeof Validation = Validation;
  PrimeNgConfig: typeof PrimeNgConfig = PrimeNgConfig;

  tableColumns: TableColumn[];                                // column headers and fields to display on the table
  selectedRowIndex: number;
  editable: boolean = false;

  maxEndOn: Date;
  displayDialog: boolean;
  salaryHistoryToEdit: SalaryHistory;
  positionTypeDropDown: SelectItem[] = [];

  @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;

  constructor(private confirmationService: ConfirmationService, private transform: CommonTransformationService,
              private hrService: HrService, private dataService: SalaryHistoryDataService, private user: UserService,
              private primeNgService: PrimeNgSupportService) {
  }

  ngOnInit() {
    this.getPositions();
    this.maxEndOn = new Date();
  }

  ngAfterViewInit(): void {
    this.buidlTableColumns();
  }


  ngOnChanges(changes: SimpleChanges): void {

    if (this.userId && !this.salaryHistories) {
      console.log("retrieving salary history");
      this.dataService.searchSalaryHistory(this.userId).subscribe(res => {
        this.salaryHistories = plainToClass(SalaryHistory, res.list);
      });
    } else {
      console.log("processing input salary history");
    }
  }

  getPositions() {
    this.hrService.getPositionsAsDropDown().subscribe(positions => {
      this.positionTypeDropDown = positions;
    });
  }

  /**
   * @desc show a pop up dialog to gather new Training History information
   * @returns this.copiedRow - instantiated
   *          this.displayDialog - set to true, so popup dialog is shown to gather a new *Training History info
   */
  onClickAddRow() {

    this.salaryHistoryToEdit = new SalaryHistory();
    this.salaryHistoryToEdit.userId = this.user.info.userId;
    this.displayDialog = true;
  }

  /**
   * @desc edit an existing Training History
   * @param salaryHistory - selected Training History to edit
   * @returns this.copiedRow - has copy of the selected Training History
   *          displayDialog - set it to true which in turn open up an edit dialog
   */
  onClickEditRow(salaryHistory: SalaryHistory) {

    this.salaryHistoryToEdit = classToClass(salaryHistory);
    this.salaryHistoryToEdit.userId = this.user.info.userId;
    const rowIndex = this.salaryHistories.indexOf(salaryHistory);
    this.selectedRowIndex = rowIndex;

    this.displayDialog = true;
  }

  /**
   * @desc save new Training History to the inputArray
   * @param salaryHistory - either new or selected Training History for edit
   * @returns: this.inputArray - new Training History added to the this array
   */
  onClickSaveRow(salaryHistory: SalaryHistory) {

    if (this.selectedRowIndex >= 0) {
      this.salaryHistories = this.primeNgService.replaceByIndex(this.salaryHistories, salaryHistory, this.selectedRowIndex);
      this.selectedRowIndex = -1;
    } else {
      this.salaryHistories = this.primeNgService.unshift(this.salaryHistories, salaryHistory);
    }
    this.displayDialog = false;
  }

  /**
   * @desc delete the selected row from the inputArray
   * @returns: this.inputArray - removed input row from the array
   * @param rowIndex
   */
  onClickDeleteRow(salaryHistory: SalaryHistory) {
    const rowIndex = this.salaryHistories.indexOf(salaryHistory);
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this Training History?',
      header: 'Delete Training History',
      icon: 'fa fa-question-circle',
      accept: () => {
        if (rowIndex >= 0) {
          this.salaryHistories = this.primeNgService.deleteByIndex(this.salaryHistories, rowIndex);
        }
      },
      reject: () => {
      }
    });
  }

  onClickSaveSalaryHistory(): void {
    this.dataService.updateSalaryHistory(this.salaryHistories).subscribe(salHistories => {

    });
  }

  private buidlTableColumns(): void {
    this.tableColumns = [
      {field: 'changedBy', header: 'Changed By', format: TableFormat.TitleCase},
      {field: 'positionTitle', header: 'Position'},
      {field: 'annualSalary', header: 'Annual Salary', format: TableFormat.Currency},
      {field: 'hourlySalary', header: 'Hourly Salary', format: TableFormat.Currency},
      {field: 'effectiveOn', header: 'Effective On', format: TableFormat.Date},
      {field: 'lowPointSalary', header: 'Salary Low Point', format: TableFormat.Currency},
      {field: 'highPointSalary', header: 'Salary High Point', format: TableFormat.Currency},
    ];

    if (this.editable) {
      this.tableColumns.push({field: 'action', header: 'Action', template: this.actionTemplate});
    }
    this.tableColumns = [...this.tableColumns];
  }

}
